<section class="space-ptb pt-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-02 mb-5 text-left">
              <h2>{{ resume?.profile?.title }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <div class="resume-base bg-light user-dashboard-info-box">
              <div class="profile">
                <div class="jobber-user-info">
                  <div class="profile-avatar">
                    <img class="img-fluid" [src]="photoPath" alt="" />
                  </div>
                  <div class="profile-avatar-info mt-3">
                    <h5>{{ resume?.profile?.name }}</h5>
                  </div>
                </div>
              </div>
              <div class="about-candidate border-top">
                <div class="candidate-info">
                  <h6>Location:</h6>
                  <p>
                    {{ resume?.profile?.city }}, {{ resume?.profile?.country }}
                  </p>
                </div>
                <div class="candidate-info">
                  <h6>Gender:</h6>
                  <p>{{ resume?.profile?.gender }}</p>
                </div>
                <div class="candidate-info">
                  <h6>Languages:</h6>
                  <p style="word-wrap: break-word">{{ languages }}</p>
                </div>
                <div class="candidate-info">
                  <h6>Experience:</h6>
                  <p>{{ experienceInYears(resume?.profile?.experience) }}</p>
                </div>
                <div class="candidate-info">
                  <h6>Primary Sector:</h6>
                  <p>{{ resume?.profile?.sector }}</p>
                </div>
                <div class="candidate-info" *ngIf="resume?.id">
                  <app-report-as-malicious buttonText="Report Profile" [recordIdToReport]="resume.id"
                    [recordTypeToReport]="entityTypeEnum.resume"></app-report-as-malicious>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="resume-experience pl-0">
              <div class="timeline-box">
                <h5 class="resume-experience-title">About Me:</h5>
                <div class="jobber-candidate-timeline mt-4">
                  <p>{{ resume?.aboutMe }}</p>
                </div>
              </div>
              <div class="mt-4">
                <h5>Professional Skills:</h5>
                <div class="progress" *ngFor="let skill of resume?.skills">
                  <div class="progress-bar" role="progressbar" [style.width]="skill.levelPercentage"
                    [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar-title">{{ skill.title }}</div>
                    <span class="progress-bar-number">{{
                      skill.levelPercentage
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="timeline-box" *ngIf="resume?.portfolioAttachments?.length > 0">
                <h5 class="resume-experience-title">Portfolio:</h5>
                <div class="jobber-candidate-timeline mt-4">
                  <app-attachments-preview [componentType]="componentTypes.PortfolioComponent" [canDelete]="false">
                  </app-attachments-preview>
                </div>
              </div>
              <div class="timeline-box mt-4">
                <h5 class="resume-experience-title">Work & Experience:</h5>
                <div class="jobber-candidate-timeline mt-4">
                  <div *ngIf="showBriefCase == true" class="jobber-timeline-icon">
                    <i class="fas fa-briefcase"></i>
                  </div>
                  <div *ngFor="let experience of resume?.experiences; let i = index">
                    <app-experience-preview [experience]="experience" [index]="i" [readonly]="true">
                    </app-experience-preview>
                  </div>
                </div>
              </div>
              <div class="timeline-box">
                <h5 class="resume-experience-title">Education:</h5>
                <div class="jobber-candidate-timeline mt-4">
                  <div *ngIf="showEducationCap == true" class="jobber-timeline-icon">
                    <i class="fas fa-graduation-cap"></i>
                  </div>
                  <app-education-preview *ngFor="let education of resume?.educations; let i = index"
                    [education]="education" [index]="i" [readonly]="true"></app-education-preview>
                </div>
              </div>
              <div class="mt-4">
                <h5>Certifications:</h5>
                <ng-container class="" *ngFor="let skill of resume?.certificates">
                  <p>{{ skill.title }}</p>
                </ng-container>
              </div>
              <h5>Reviews:</h5>
              <div class="mt-4">
                <ng-container *ngFor="let review of resume?.reviews">
                  <div class="d-flex mb-2">
                    <div class="mt-2">
                      <img alt="User Avatar" class="rounded-circle" [src]="review?.reviewedByLogo | imagePath">&nbsp;
                    </div>
                    <div>
                      <p class="font-weight-bold mb-0">{{ review.jobTitle }}</p>
                      {{ review?.reviewedByUsername }}
                      &nbsp;
                      <ngb-rating [max]="5" [rate]="review?.reviewRating" [readonly]="true">
                      </ngb-rating>
                      &nbsp;
                      {{ review?.reviewText }}
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="back-to-top" class="back-to-top" (click)="scrollToTop()">
  <i class="fas fa-angle-up" (click)="scrollToTop()"></i>
</div>